// extracted by mini-css-extract-plugin
export default {"container":"modal_container__MYokX","button":"modal_button__bvl4B","text":"modal_text__4Etyi"};